module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-latin488.30ad38e.woff2";